// extracted by mini-css-extract-plugin
module.exports = {"CalculatorBackButton":"CalculatorBackButton_CalculatorBackButton__7ZZ0z","Chev":"CalculatorBackButton_Chev___F1-7"};